import { Component } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ForgotPasswordService } from "../Service/ForgotPassword.Service";
import { ForgotPasswordModel } from "../../model/index"
import { Title } from '@angular/platform-browser';

declare var require: any;
@Component({
    selector: 'MentisSoft-ForgotPassword',
    template: require('../Template/ForgotPassword.template.html'),
    styles: [require('../Template/ForgotPassword.css')]
})

export class ForgotPasswordComponent {
    constructor(private router: Router, private route: ActivatedRoute, private _ForgotPasswordService: ForgotPasswordService, private _titleService: Title
    ) {
    }
    loading = false;
    ForgotPasswordInfo: ForgotPasswordModel = new ForgotPasswordModel();
    isValidInfo: boolean = true;
    errMsg: string = "";
    HospitalName: string = "";
    ngAfterViewInit() {
        $('#overlay').hide();
        this.HospitalName = localStorage.getItem("HospitalName");
        if (this.HospitalName == "BSH")
            this.HospitalName = "FALSE";
        else
            this.HospitalName = "TRUE";
    }
    ForgotSubmit(event) {
        this._titleService.setTitle("ForgotPassword");
        this.loading = true;

        if (this.ForgotPasswordInfo !== null &&
            this.ForgotPasswordInfo.patientid !== null && this.ForgotPasswordInfo.patientid !== "" && this.ForgotPasswordInfo.patientid !== undefined &&
            this.ForgotPasswordInfo.username !== null && this.ForgotPasswordInfo.username !== "" && this.ForgotPasswordInfo.username !== undefined
            && this.ForgotPasswordInfo.email !== null && this.ForgotPasswordInfo.email !== "" && this.ForgotPasswordInfo.email !== undefined) {
            this._ForgotPasswordService.validCredentials(this.ForgotPasswordInfo)
                .subscribe(
                p => {
                    this.loading = false;
                    if (p.IsValid) {
                        this.errMsg = "The new password has been generated and sent to your registered email address.Please login with your new password."
                    }

                    else {
                        this.errMsg = "The Information You are Provided is Not Matching, Please Verify the Information!";
                    }
                }
                ,
                err => {
                this.loading = false;
                    this.errMsg = "Invalid Details!";
                    console.log("Error while getting data...");
                }

                );
        }
        else {
            if ((this.ForgotPasswordInfo.username == null || this.ForgotPasswordInfo.username == "" || this.ForgotPasswordInfo.username == undefined) &&
                (this.ForgotPasswordInfo.email == null || this.ForgotPasswordInfo.email == "" || this.ForgotPasswordInfo.email == undefined) &&
                (this.ForgotPasswordInfo.patientid == null || this.ForgotPasswordInfo.patientid == "" || this.ForgotPasswordInfo.patientid == undefined)) {
                this.errMsg = "Your user name,patient id and email is required.";
            }
            else if ((this.ForgotPasswordInfo.username == null || this.ForgotPasswordInfo.username == "" || this.ForgotPasswordInfo.username == undefined) &&
                (this.ForgotPasswordInfo.patientid == null || this.ForgotPasswordInfo.patientid == "" || this.ForgotPasswordInfo.patientid == undefined) ) {
                    this.errMsg = "Your user name and Patient id is required.";
            }
            else if ((this.ForgotPasswordInfo.username == null || this.ForgotPasswordInfo.username == "" || this.ForgotPasswordInfo.username == undefined) &&
                (this.ForgotPasswordInfo.email == null || this.ForgotPasswordInfo.email == "" || this.ForgotPasswordInfo.email == undefined)) {
                this.errMsg = "Your user name and email is required.";
            }
            else if ((this.ForgotPasswordInfo.patientid == null || this.ForgotPasswordInfo.patientid == "" || this.ForgotPasswordInfo.patientid == undefined) &&
                (this.ForgotPasswordInfo.email == null || this.ForgotPasswordInfo.email == "" || this.ForgotPasswordInfo.email == undefined)) {
                this.errMsg = "Your patient id and email is required.";
            }
            else if (this.ForgotPasswordInfo.username == null || this.ForgotPasswordInfo.username == "" || this.ForgotPasswordInfo.username == undefined)
            {
                this.errMsg = "Your user name is required";
            }
            else if (this.ForgotPasswordInfo.patientid == null || this.ForgotPasswordInfo.patientid == "" || this.ForgotPasswordInfo.patientid == undefined) {
                this.errMsg = "Your patientid is required";
            }
            else if (this.ForgotPasswordInfo.email == null || this.ForgotPasswordInfo.email == "" || this.ForgotPasswordInfo.email == undefined) {
                this.errMsg = "Your email is required";
            }
            else {
                this.errMsg = "Please enter the required filed.";
            }
        }
        this.loading = false;
    }

    logBacktoLogin(event) {
        this.router.navigate(["/Login"]);
    }
    logSignUp(event) {
        this.router.navigate(["/SignUp"]);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/ForgotPassword/Component/ForgotPassword.Component.ts